import { render } from "./KappKalenderEvent.vue?vue&type=template&id=7bf16a37&scoped=true"
import script from "./KappKalenderEvent.vue?vue&type=script&lang=js"
export * from "./KappKalenderEvent.vue?vue&type=script&lang=js"

import "./KappKalenderEvent.vue?vue&type=style&index=0&id=7bf16a37&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf16a37"]])

export default __exports__